var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h2", { style: { color: "#4fa2b7" } }, [_vm._v("Building Structure")]),
    _vm._v(" "),
    _c("div", { staticClass: "d-flex align-center mt-2" }, [
      _c("div", { staticClass: "mr-3" }, [
        _c("h4", [_vm._v("Ground Floors")]),
        _vm._v(" "),
        _c("div", { staticClass: "counterItem" }, [
          _c(
            "button",
            {
              staticClass: "decreaseBtn",
              on: { click: _vm.deleteGroundFloor }
            },
            [_vm._v("-")]
          ),
          _vm._v(" "),
          _c("p", {}, [_vm._v(_vm._s(_vm.groundFloors))]),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "increaseBtn", on: { click: _vm.addGroundFloor } },
            [_vm._v("+")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mr-3" }, [
        _c("h4", [_vm._v("Underground Floors")]),
        _vm._v(" "),
        _c("div", { staticClass: "counterItem" }, [
          _c(
            "button",
            {
              staticClass: "decreaseBtn",
              on: { click: _vm.deleteUndergroundFloor }
            },
            [_vm._v("-")]
          ),
          _vm._v(" "),
          _c("p", {}, [_vm._v(_vm._s(_vm.undergroundFloors))]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "increaseBtn",
              on: { click: _vm.addUndergroundFloor }
            },
            [_vm._v("+")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mr-3" }, [
        _c("h4", [_vm._v("Columns")]),
        _vm._v(" "),
        _c("div", { staticClass: "counterItem" }, [
          _c(
            "button",
            { staticClass: "decreaseBtn", on: { click: _vm.deleteColumn } },
            [_vm._v("-")]
          ),
          _vm._v(" "),
          _c("p", {}, [_vm._v(_vm._s(_vm.columns))]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "increaseBtn",
              on: {
                click: function($event) {
                  return _vm.$emit("add-column")
                }
              }
            },
            [_vm._v("+")]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22810974", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22810974","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Buildings/Vertical/VerticalStructureButtons.vue
// module id = null
// module chunks = 